import { useContext } from "react";
import { brandInfo } from "../../../constant";
import { useElement } from "../../../hooks";
import { SubscriptionForm } from "../SubscriptionForm";
import { AppContext } from "../../../context";

export const SubscriptionBar = () => {
  const { selectors: { getLogo } } = useContext(AppContext);
  const logo = getLogo() || brandInfo.logo;
  const Link = useElement("Link");
  const Img = useElement("Img");

  return (
    <section className="subscription-bar">
      <div className="wrapper jumbo-container">
        <Link href="/" className="logo">
          <Img
            source="internal"
            alt={brandInfo.name.capital}
            className="logo-right-banner"
            src={logo}
          />
        </Link>
        <SubscriptionForm />
      </div>
    </section>
  );
};
